import { useReactiveVar } from '@apollo/client';
import { featureFlagsVar } from '../reactiveVar';
import { FlagState } from '../types';
export const useFeatureFlag = (featureKey) => {
    const featureValues = useReactiveVar(featureFlagsVar);
    const { value } = featureValues[featureKey] || {};
    const isEnabled = value === FlagState.ENABLED;
    return isEnabled;
};
